import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/de';
import isBetween from 'dayjs/plugin/isBetween';
import localeData from 'dayjs/plugin/localeData';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(LocalizedFormat);
dayjs.extend(localeData);
dayjs.extend(isBetween);

export type AppDate = Dayjs;

export class Dates {
  static setLocale(locale: string): void {
    dayjs.locale(locale);
  }

  static getToday(): AppDate {
    return dayjs();
  }

  static getTodayInUtc(): AppDate {
    return dayjs();
  }

  static getClearDate(): AppDate {
    return this.getToday().hour(0).minute(0).second(0).millisecond(0);
  }

  static clearDate(date: number | string): AppDate {
    return this.getDate(date).hour(0).minute(0).second(0).millisecond(0);
  }

  static getMonths(): string[] {
    return dayjs.months();
  }

  static getDays(): string[] {
    return dayjs.weekdaysShort();
  }

  static getDate(date: number | string): AppDate {
    return dayjs(date);
  }

  static isDatePassed(date: AppDate): boolean {
    return date.isBefore(this.getToday()) || date.isSame(this.getToday(), 'day');
  }

  private static isValidDateInput(date: AppDate | string | number | Date): boolean {
    return typeof date === 'string' || date instanceof Date;
  }

  static format(date: AppDate | string | number | Date, query = 'DD/MM/YYYY'): string {
    if (this.isValidDateInput(date)) {
      return dayjs(date).format(query);
    }
    if (typeof date === 'number') {
      return dayjs.unix(date).format(query);
    }
    return (date as AppDate).format(query);
  }

  static get12HoursFormat(date: number): string {
    const today = dayjs().hour(0).minute(0).second(0).millisecond(date);
    return today.format('hh:mm A');
  }
}
